import { Form, Modal, Table } from "antd";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const FormContainer = styled.div`
  form {
    display: flex;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 600;
  align-items: center;
  margin-top: 5px;
  font-family: "Open Sans";
  line-height: 22px;
`;

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 15px;
  padding-left: 8px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.16);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const FieldsContainer = styled.div`
  margin-top: 16px;
`;

export const Horizontal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  flex-wrap: wrap;
  align-items: center;
  & > div {
    display: flex;
    flex: 1 0 100px;
    margin-left: 16px;
  }

  & > div:first-child {
    margin-left: 0px;
  }
`;

export const ButtonAdd = styled.button`
  min-width: 181px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  margin-left: 2%;
  padding-inline: 16px;
  border-radius: 5px;
  background-color: rgba(0, 34, 68, 1);
  color: rgba(255, 255, 255, 1);
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-size: 14px;
  font-weight: 700;
  font-family: "Inter";
  border: none;
  white-space: nowrap;
  text-transform: uppercase;
  @media (max-width: 500px) {
    font-size: 12px;
    width: 80%;
    padding-inline: 5px;
  }
`;

export const ButtonItens = styled.button`
  min-width: 126px;
  height: 34px;
  margin: 8px 0px;
  padding-inline: 16px;
  border-radius: 5px;
  background-color: rgba(226, 232, 240, 1);
  color: rgba(0, 34, 68, 1);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  font-family: "Inter";
  border: none;
  align-items: center;
  justify-content: center;
  display: flex;
  white-space: nowrap;
  text-transform: uppercase;

  &:disabled {
    background-color: rgba(200, 200, 200, 1);
    color: rgba(150, 150, 150, 1);
    cursor: not-allowed;
    transform: none;
  }

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: 10px;
    padding-inline: 12px;
  }

  @media (max-width: 615px) {
    font-size: 8px;
    width: 95%;
    min-width: unset;
    text-transform: none;
    padding-inline: 5px;
    margin: auto;
  }
  @media (max-width 465px) {
    font-size: 8px;
    width: 50%;
    min-width: unset;
  }
`;

export const IconItensDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconItensDivMobile = styled.div`
  @media (max-width: 500px) {
    display: none;
  }
`;

export const ButtonDelete = styled.button`
  width: 268px;
  justify-content: center;
  height: 34px;
  padding-inline: 16px;
  border-radius: 5px;
  background-color: rgba(226, 232, 240, 1);
  color: rgba(0, 34, 68, 1);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  font-family: "Inter";
  border: none;
  align-items: center;
  display: flex;
  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 16px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 10px 10px 10px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding-left: 20px;
  }
`;

export const ModalCreateAndEdit = styled(Modal)`
  .ant-modal {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-modal-footer {
    border: none;
  }
  .ant-modal-header {
    border-radius: 8px 8px 0 0;
  }

  .ant-modal-content {
    height: 230px;
    max-width: 600px;
    border-radius: 8px;
  }

  .ant-modal-title {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 700;
    border-radius: 8px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ModalDelete = styled(Modal)`
  border-radius: 8px;
  .ant-modal {
    border-radius: 8px;
    overflow: hidden;
  }
  .ant-modal-footer {
    border: none;
  }
  .ant-modal-header {
    border-radius: 8px 8px 0 0;
  }

  .ant-modal-content {
    max-width: 600px;
    min-height: 158px;
    border-radius: 8px;
  }
  .ant-modal-title {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 700;
    border-radius: 8px;
    text-align: center;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ModalSubtitle = styled.div`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 600;
  margin-top: -10px;
`;

export const FormItem = styled(Form.Item)`
  .ant-form-item-label > label {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 12px;
  }
`;

export const LinkButton = styled(Link)`
  text-decoration: none;
`;
export const ResponsiveTableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 32px;

  @media (max-width: 768px) {
    overflow-x: auto;
  }
`;

export const TableWrapper = styled(Table)`
  width: 100%;
  .ant-table-container {
    overflow-x: auto; s
  }

  .ant-table-thead > tr > th {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }

  .ant-table-tbody > tr > td {
    padding: 8px 16px;
    font-size: 14px;
    text-align: left;
  }

  @media (max-width: 768px) {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 8px 8px; 
      font-size: 12px;
    }
  }

  @media (max-width: 500px) {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      font-size: 12px;
    }
  }
`;
